import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import Tooltip from "@tippyjs/react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "tippy.js/dist/tippy.css";
import { ToastContainer, toast } from "react-toastify";

import EditUserService from "../../../services/user/editUserService";
import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import AuthUserChangePassword from "../../../services/helper/changeUserPassword";
import AuthService from "../../../services/auth.service";

function EditCustomerUser() {
 
  const { state } = useLocation();
 
  const [user, setUser] = useState("");
  const [name, setName] = useState("");
  const [lastname, setLastName] = useState("");

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [successful, setSuccessful] = useState(false);
  const [disable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();

  useEffect(() => {
    EditUserService.getCustomerUser(state).then((response) => {
      setName(response.data[0]?.first_name);
      setLastName(response.data[0]?.last_name);
      setPhone(response.data[0]?.phone_number);
      setEmail(response.data[0]?.user.email);
      setUser(response.data[0]?.user);

      reset({
        name: response.data.first_name,
        lastname: response.data.last_name,
        // timezone: response.data.timezone,
      });
    })
  
  }, []);

  let navigate = useNavigate();

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    setDisable(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditUserService.editCustomerUser(
        state,
        name,
        lastname,
        email,
        phone,
        user
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          setTimeout(() => {
            setDisable(false);
            navigate("/user");
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
          setDisable(false);
          setLoading(false);

        }
      })
      
    }
  };

  const handelClick = () => {
    navigate("/user");
  };
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [cnfPassword, setCnfPassword] = useState("");

  const handleChangePassword = () => {
    if (cnfPassword === newPassword) {
      AuthUserChangePassword.UserPassword({
        email: email,
        password: cnfPassword,
        currentpassword: password,
      }).then((res) => {
        if (res.data.success === 0) {
          toast.error(res.data.error, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.success(res.data.response, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          // localStorage.setItem("last_login",res.data.lastlogin)
          setTimeout(() => {
            // navigate("/profile");
          }, 3000);
        }
      })
     
    } else {
      toast.error("Confirm Password and New Password not same", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  // const handleChangeUserPassword = () => {
  //   confirmAlert({
  //     title: <h3 className="tc">Change Password</h3>,
  //     message: (
  //       <div className="">
  //         <label>Current Password</label>
  //         <div className="mb-3">
  //           <input
  //             className="form-control  validate black-text"
  //             name="Password"
  //             type="Password"
  //             placeholder="Password"
  //             onChange={(e) => setPassword(e.target.value)}
  //           />
  //         </div>
  //         <label>New Password</label>
  //         <div className="mb-3">
  //           <input
  //             className="form-control  validate black-text"
  //             name="Password"
  //             type="Password"
  //             placeholder="Password"
  //             onChange={(e) => setNewPassword(e.target.value)}
  //           />
  //         </div>
  //         <label>Confirm Password</label>
  //         <div className="mb-3">
  //           <input
  //             className="form-control"
  //             name="password2"
  //             type="password"
  //             placeholder="Confirm Password"
  //             onChange={(e) => setCnfPassword(e.target.value)}
  //           />
  //         </div>
  //       </div>
  //     ),
  //     buttons: [
  //       {
  //         label: "Confirm",
  //         onClick: () => {
  //           handleChangePassword();
  //           // handlechangeusersubscription()
  //         },
  //         className: "confirm-button",
  //       },
  //       {
  //         label: "No",
  //         // style:{
  //         //   background:'grey',
  //         //   color:'white'
  //         // },
  //         className: "no-button",
  //       },
  //     ],
  //   });
  // };

  const handleChangeUserPassword = () => {
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      // AuthService.forgotpassword(email).then(
      AuthService.resetpassword(email).then(
        (data) => {
          if (data.data.success === 1) {
            toast.success("Successfully send email",
              {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
          }
          else {
            toast.error(`${data.data.error}`,
              {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
          }
        },
      )
    
    } else {
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="header pt-3">
            <h5 className="mb-3 tc">{t("Edit User")}</h5>
          </div>
          <ToastContainer />
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <Form
                    role="form text-left"
                    onSubmit={handleSubmit(handleRegister)}
                    ref={form}
                    action="."
                    method="POST"
                    id="addPartyForm"
                  >
                    {
                      <>
                        <div className="form-group row">
                          <div className="col-md-6">
                            <label className="col-form-label required">
                              {t("Name")}{" "}
                              <Tooltip content={t("Name_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              placeholder="Name"
                              value={name}
                              {...register("name", {
                                onChange: (e) => {
                                  setName(e.target.value);
                                },
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors.name?.type === "required" &&
                                "Name  is required"}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label className="col-form-label required">
                              {t("Last Name")}{" "}
                              <Tooltip content={t("Name_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="lastname"
                              placeholder="LastName"
                              value={lastname}
                              {...register("lastname", {
                                onChange: (e) => {
                                  setLastName(e.target.value);
                                },
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors.lastname?.type === "required" &&
                                "Last Name  is required"}
                            </div>
                          </div>
                        </div>

                        <div className="form-group row">
                          <div className="col-sm-6">
                            <label className="col-form-label required">
                              {t("Email")}{" "}
                              <Tooltip content={t("Email_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              type="email"
                              disabled
                              className="form-control"
                              name="email"
                              placeholder="Email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-6">
                            <label className="col-form-label">
                              {t("Phone")}{" "}
                              <Tooltip content={t("Phone_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <PhoneInput
                              country={"us"}
                              value={phone}
                              onChange={(phone) => setPhone(phone)}
                            />
                            {/* <input
                              type="number"
                              className="form-control"
                              name="phone"
                              placeholder="Phone"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                            /> */}
                          </div>
                        </div>
                        <div className="text-left py-3">
                          <button
                            type="button"
                            onClick={handelClick}
                            className="btn btn-secondary btn-md"
                          >
                            {t("Cancel")}
                          </button>
                          &nbsp;
                          <button
                            type="submit"
                            disabled={disable}
                            className="border-0 btn btn-primary btn-gradient-primary btn-md"
                          >
                            {loading === false ? t("Save") : <ButtonLoading />}
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type="button"
                            onClick={() => handleChangeUserPassword()}
                            className="border-0 btn btn-primary btn-gradient-primary btn-md"
                          >
                            {t("Reset Password")}
                          </button>
                          &nbsp;&nbsp;
                        </div>
                      </>
                    }
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditCustomerUser;
